import { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { SignUpFormContext } from "../sign-up-form.context";
import { TextLinkComponent, TypographyComponent } from "@gx1/gx-ui-common";
import { navigateToUrl } from "single-spa";
import ErrorBannerComponent from "../../../../ui/error-banner/error-banner.component";
import styles from "./sign-up-form-header.styles.module.scss";

const SignUpFormHeader = () => {
  const { t } = useTranslation();
  const { surveyId, page, errorText } = useContext(SignUpFormContext);

  return (
    <Fragment>
      <div className={styles.signUpHeading}>
        <div className={styles.signUpHeadingTitle}>
          <TypographyComponent styling={"h5"} boldness={"semi"} element={"h2"} color={"grey9"}>
            {page === 2 ? t("Tell us about yourself") : t("Create a Gartner BuySmart account")}
          </TypographyComponent>
          {!surveyId && (
            <TypographyComponent styling="p-sm" boldness="regular" color="grey7">
              {page}
              {t(" of 2")}
            </TypographyComponent>
          )}
        </div>
        <div className={styles.signUpHeadingLogin}>
          {page === 1 && (
            <TypographyComponent styling="p-sm" element="p" color="grey9">
              <TextLinkComponent
                href={"/login"}
                onClick={() => navigateToUrl("/login")}
                text={t("Log in")}
                size={"small"}
                variant={"prominent"}
              />
              {` ${t("if you already have an account")}`}
            </TypographyComponent>
          )}
          {page === 2 && (
            <TypographyComponent styling="p-sm" element="p" color="grey9">
              {t("To personalize your experience, tell us a little bit about what kind of work you do.")}
            </TypographyComponent>
          )}
        </div>
        {Boolean(errorText) && <ErrorBannerComponent message={errorText} />}
      </div>
    </Fragment>
  );
};

export default SignUpFormHeader;
